import _ from 'lodash';
import React, { useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import useForm from '@jumbo/utils/useForm';
import { IniciarPresupuestoCobrosBruto, SolicitarEjecucion } from '../../redux/actions/Ejecucion';
import { Typography } from '@material-ui/core';
import { Divider } from '@material-ui/core';
import { ValorSelect } from './utils/Helper';
import Autocompetesinapp from './utils/Autocompetesinapp';
import Pickersinapp from './utils/Pickersinapp';
import { KeyboardDatePicker } from '@material-ui/pickers';
import useStyles from '@jumbo/components/ListadoEjecucion/EjecucionStyle';
import { NumberFormatEnteroPositivo } from './utils/NumberFormatCustom';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

const PresupuestoCobrosBrutos = ({ open, onCloseDialog, formApp }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { usuarioID } = useSelector(({ auth }) => auth.authUser);
  const {
    hotel,
    hotelgroup,
    touroperator,
    touroperatorgroup,
    market,
    paymentcondition,
    cartera,
    frecuency,
    PresupuestoCobroTipo,
    PresupuestoCobroIncluirOtrasCuentas,
    PresupuestoCobroGuardar,
  } = useSelector(({ ejecucion }) => ejecucion);
  const { form, setForm } = useForm({
    PRESUPUESTOCOBROTIPO: '12',
    FechaGeneracionPresupuesto: null,
    collectionbudgedate: null,
    agebalancedate: null,
    hotel: null,
    hotelgroup: null,
    touroperator: null,
    touroperatorgroup: null,
    market: null,
    paymentcondition: null,
    cartera: null,
    forecastcollectionsbudgetmonth: null,
    frecuencia: '',
    SheetConsolidado: 'Si',
    PRESUPUESTOCOBROINCLUIROTRASCTAS: '14',
    PRESUPUESTOCOBROGUARDAR: '17',
  });

  useEffect(() => {
    dispatch(IniciarPresupuestoCobrosBruto());
  }, [dispatch]);

  const ejecucion = () => {
    let variables = '';

    if (form.collectionbudgedate) {
      variables += `${form.collectionbudgedate}`;
    } else {
      variables += 'null';
    }

    if (form.hotel) {
      variables += `|${form.hotel}`;
    } else {
      variables += '|null';
    }

    if (form.hotelgroup) {
      variables += `|${form.hotelgroup}`;
    } else {
      variables += '|null';
    }

    if (form.touroperator) {
      variables += `|${form.touroperator}`;
    } else {
      variables += '|null';
    }

    if (form.touroperatorgroup) {
      variables += `|${form.touroperatorgroup}`;
    } else {
      variables += '|null';
    }

    if (form.paymentcondition) {
      variables += `|${form.paymentcondition}`;
    } else {
      variables += '|null';
    }

    if (form.market) {
      variables += `|${form.market}`;
    } else {
      variables += '|null';
    }

    if (form.cartera) {
      variables += `|${form.cartera}`;
    } else {
      variables += '|null';
    }

    if (form.forecastcollectionsbudgetmonth) {
      variables += `|${form.forecastcollectionsbudgetmonth}`;
    } else {
      variables += '|null';
    }

    if (form.frecuencia) {
      variables += `|${form.frecuencia}`;
    } else {
      variables += '|null';
    }

    if (form.agebalancedate) {
      variables += `|${form.agebalancedate}`;
    } else {
      variables += '|null';
    }

    if (form.SheetConsolidado) {
      variables += `|${form.SheetConsolidado}`;
    } else {
      variables += '|null';
    }

    if (form.PRESUPUESTOCOBROTIPO) {
      variables += `|${form.PRESUPUESTOCOBROTIPO}`;
    } else {
      variables += '|null';
    }
    if (form.FechaGeneracionPresupuesto) {
      variables += `|${form.FechaGeneracionPresupuesto}`;
    } else {
      variables += '|null';
    }

    if (form.PRESUPUESTOCOBROINCLUIROTRASCTAS) {
      variables += `|${form.PRESUPUESTOCOBROINCLUIROTRASCTAS}`;
    } else {
      variables += '|null';
    }
    if (form.PRESUPUESTOCOBROGUARDAR) {
      variables += `|${form.PRESUPUESTOCOBROGUARDAR}`;
    } else {
      variables += '|null';
    }

    let Solicitar = {
      FormAppID: formApp.formAppID,
      UsuarioID: usuarioID,
      OrdenarPorID: null,
      Computador: '192.163',
      UserNameComputador: '192.163',
      ValorVersion: null,
      CriteriosEjecucion: variables,
      CriteriosEjecucionExclusion: '',
    };

    dispatch(SolicitarEjecucion(Solicitar));
  };

  return (
    <Dialog open={open} className={classes.dialogRoot} fullWidth maxWidth="md">
      <DialogTitle className={classes.dialogTitleRoot}>{formApp.titulo} </DialogTitle>
      <DialogContent dividers>
        <div className={classes.root}>
          <Typography variant="h4">Criterios de Búsqueda</Typography>
          <Divider classes={{ root: classes.divider }} />

          <div>
          <FormControl component="fieldset">
            <FormLabel component="legend">Budget Type</FormLabel>
            <RadioGroup
              row
              name="presupuestoCobroTipo"
              value={form.PRESUPUESTOCOBROTIPO ?? '12'} 
              onChange={(e) =>
                setForm({
                  ...form,
                  PRESUPUESTOCOBROTIPO: e.target.value,
                })
              }
            >
              <FormControlLabel
                value={'12'}
                control={<Radio color="primary" />}
                label="Gross Budget"
              />
              <FormControlLabel
                value={'13'}
                control={<Radio color="primary" />}
                label="Net Budget"
              />
            </RadioGroup>
          </FormControl>
          </div>

          {/* <Autocompetesinapp
            disableCloseOnSelect
            value={PresupuestoCobroTipo.find(opt => opt.value === form.PRESUPUESTOCOBROTIPO) || null}
            options={PresupuestoCobroTipo}
            name="Seleccione un Tipo de Presupuesto"
            onChange={(event, newValue) => {
              setForm(_.set({ ...form }, 'PRESUPUESTOCOBROTIPO', ValorSelect(newValue)));
            }}
          /> */}

          <Pickersinapp
            label="Generation Date"
            value={form.FechaGeneracionPresupuesto}
            onChange={date => {
              date !== null
                ? setForm(_.set({ ...form }, 'FechaGeneracionPresupuesto', `${date.format('YYYYMMDD')}`))
                : setForm(_.set({ ...form }, 'FechaGeneracionPresupuesto', null));
            }}
            style={{ paddingRight: 10, width: 350 }}
          />

          <div>
            <KeyboardDatePicker
              openTo="year"
              views={['year', 'month']}
              size="small"
              autoOk
              disableToolbar
              variant="inline"
              format="MM/YYYY"
              label="Collection Budget Date"
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              inputVariant="outlined"
              className={classes.textlabel}
              value={form.collectionbudgedate}
              onChange={date => {
                date !== null
                  ? setForm(_.set({ ...form }, 'collectionbudgedate', `${date.format('YYYYMM')}`))
                  : setForm(_.set({ ...form }, 'collectionbudgedate', null));
              }}
              style={{ paddingRight: 10, width: 350 }}
            />
          </div>
          <Pickersinapp
            label="Cutoff Date"
            value={form.agebalancedate}
            onChange={date => {
              date !== null
                ? setForm(_.set({ ...form }, 'agebalancedate', `${date.format('YYYYMMDD')}`))
                : setForm(_.set({ ...form }, 'agebalancedate', null));
            }}
            style={{ paddingRight: 10, width: 350 }}
          />

          <Autocompetesinapp
            multiple
            disableCloseOnSelect
            options={hotel}
            name="Hotel"
            onChange={(event, newValue) => {
              setForm(_.set({ ...form }, 'hotel', ValorSelect(newValue)));
            }}
          />

          <Autocompetesinapp
            options={hotelgroup}
            name="Hotel Group"
            onChange={(event, newValue) => {
              setForm(_.set({ ...form }, 'hotelgroup', ValorSelect(newValue)));
            }}
          />

          <Autocompetesinapp
            multiple
            disableCloseOnSelect
            options={touroperator}
            name="Tour Operator"
            onChange={(event, newValue) => {
              setForm(_.set({ ...form }, 'touroperator', ValorSelect(newValue)));
            }}
          />

          <Autocompetesinapp
            multiple
            disableCloseOnSelect
            options={touroperatorgroup}
            name="Tour Operator Group"
            onChange={(event, newValue) => {
              setForm(_.set({ ...form }, 'touroperatorgroup', ValorSelect(newValue)));
            }}
          />

          <Autocompetesinapp
            multiple
            disableCloseOnSelect
            options={market}
            name="Market"
            onChange={(event, newValue) => {
              setForm(_.set({ ...form }, 'market', ValorSelect(newValue)));
            }}
          />

          <Autocompetesinapp
            multiple
            disableCloseOnSelect
            options={paymentcondition}
            name="Payment Condition"
            onChange={(event, newValue) => {
              setForm(_.set({ ...form }, 'paymentcondition', ValorSelect(newValue)));
            }}
          />

          <Autocompetesinapp
            multiple
            disableCloseOnSelect
            options={cartera}
            name="Portfolio"
            onChange={(event, newValue) => {
              setForm(_.set({ ...form }, 'cartera', ValorSelect(newValue)));
            }}
          />

          <div>
            <TextField
              className={classes.textlabel}
              size="small"
              label="Forecast Collections Budget Month"
              variant="outlined"
              value={form.forecastcollectionsbudgetmonth}
              onChange={value => setForm(_.set({ ...form }, 'forecastcollectionsbudgetmonth', value.target.value))}
              style={{ width: 350 }}
              InputProps={{
                inputComponent: NumberFormatEnteroPositivo,
              }}
            />
          </div>

          <Autocompetesinapp
            options={frecuency}
            name="Frecuency"
            onChange={(event, newValue) => {
              setForm(_.set({ ...form }, 'frecuencia', ValorSelect(newValue)));
            }}
          />

          {/* <Autocompetesinapp
            options={[
              { value: 'Si', label: 'Si' },
              { value: 'No', label: 'No' },
            ]}
            value={
              [
                { value: 'Si', label: 'Si' },
                { value: 'No', label: 'No' },
              ].find(opt => opt.value === form.SheetConsolidado) || null
            }
            name="¿Incluir SubTotales en Sheet Consolidado?"
            onChange={(event, newValue) => {
              setForm(_.set({ ...form }, 'SheetConsolidado', ValorSelect(newValue)));
            }}
            label="¿Incluir SubTotales en Sheet Consolidado?"
          />

          <Autocompetesinapp
            disableCloseOnSelect
            options={PresupuestoCobroIncluirOtrasCuentas}
            value={
              PresupuestoCobroIncluirOtrasCuentas.find(opt => opt.value === form.PRESUPUESTOCOBROINCLUIROTRASCTAS) || null
            }
            name="Incluir Otras Cuentas"
            onChange={(event, newValue) => {
              setForm(_.set({ ...form }, 'PRESUPUESTOCOBROINCLUIROTRASCTAS', ValorSelect(newValue)));
            }}
          />

          <Autocompetesinapp
            disableCloseOnSelect
            options={PresupuestoCobroGuardar}
            value={PresupuestoCobroGuardar.find(opt => opt.value === form.PRESUPUESTOCOBROGUARDAR) || null}
            name="Guardar Presupuesto"
            onChange={(event, newValue) => {
              setForm(_.set({ ...form }, 'PRESUPUESTOCOBROGUARDAR', ValorSelect(newValue)));
            }}
          /> */}



<FormControlLabel
  control={
    <Checkbox
      checked={form.SheetConsolidado === 'Si'}
      onChange={x =>
        setForm({
          ...form,
          SheetConsolidado: x.target.checked ? 'Si': 'No' 
        })
      }
      color="primary"
    />
  }
  label="Subtotals - Consolidated Tab"
/>

<FormControlLabel
  control={
    <Checkbox
      checked={form.PRESUPUESTOCOBROINCLUIROTRASCTAS === '14'}
      onChange={x =>
        setForm({
          ...form,
          PRESUPUESTOCOBROINCLUIROTRASCTAS: x.target.checked ? '14' : '15'
        })
      }
      color="primary"
    />
  }
  label="PGS-DWT-ELITE-DESTIWORLD"
/>

<FormControlLabel
  control={
    <Checkbox
      checked={form.PRESUPUESTOCOBROGUARDAR === '16'}
      onChange={x =>
        setForm({
          ...form,
          PRESUPUESTOCOBROGUARDAR: x.target.checked ? '16' : '17'
        })
      }
      color="primary"
    />
  }
  label="Save Budget"
/>
        </div>

        <Box display="flex" justifyContent="flex-end" my={4}>
          <Button className={classes.button} variant="contained" onClick={onCloseDialog}>
            Cancelar
          </Button>
          <Box ml={2}>
            <Button className={classes.button} variant="contained" color="secondary" onClick={() => ejecucion()}>
              Ejecutar
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default PresupuestoCobrosBrutos;

PresupuestoCobrosBrutos.prototype = {
  open: PropTypes.bool.isRequired,
  onCloseDialog: PropTypes.func,
};
